<template>
  <div
    class="ibox float-e-margins ibox-padding"
    :class="{
      'no-padding-bottom': itemType == 'booking',
      'padding-15-18': !fromViewPage && isMobile,
    }"
    id="customer-info-block"
  >
    <div class="ibox-content inquiry_customer_mop border-style" v-if="canSeeCustomer || loggedUserRole  != 'contractor'" >
      <p class="font-size-18 bold">
        <span
          v-if="bookingCustomersData.length > 1"
          class="select-services-dropdown-title"
        >
          Customers
        </span>

        <span v-else class="select-services-dropdown-title"> Customer </span>

        <span
          style="cursor: pointer"
          data-toggle="modal"
          data-target="#addCustomersPopup"
        >
          <span class="float-right">
            <a href="javascript:;">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                  fill="#03A9F4"
                />
              </svg>
            </a>
          </span>
        </span>
      </p>
        <add-customers-popup
          :booking-customers="bookingCustomersData"
          :can-add-customer="canAddCustomer"
          :can-edit-customer="canEditCustomer"
          :allObject="allObject"
          :event="event"
        >
        </add-customers-popup>

        <customer-info
          v-if="bookingCustomersData.length && bookingCustomersData.length > 1"
          v-for="(customer, index) in bookingCustomersData"
          :key="`customer-${index}-${customer.customer_id}`"
          item-type="booking"
          :counter="counter + 1"
          :customer-id="customer.customer_id"
          :event="event"
          :item-id="itemId"
          :estimate-id="estimateId"
          :has-estimate="hasEstimate"
          :invoice-id="customer.invoice_id ?? invoiceId"
          :from-view-page="true"
          :customer-signed="null"
          :customer-signature-id="customerSignatureId"
          :show-address="showAddress"
          :signature-link="signatureLink"
          :all-labels="allLabels"
        >
        </customer-info>

        <customer-info
          v-else
          item-type="booking"
          :event="event"
          :customer-id="customerId"
          :item-id="itemId"
          :estimate-id="estimateId"
          :has-estimate="hasEstimate"
          :invoice-id="invoiceId"
          :from-view-page="true"
          :customer-signed="null"
          :customer-signature-id="customerSignatureId"
          :show-address="showAddress"
          :signature-link="signatureLink"
          :all-labels="allLabels"
        >
        </customer-info>
      </div>
      <div v-else class="ibox-content inquiry_customer_mop border-style">
        <span class="select-services-dropdown-title">Customer details hidden</span>
        <p style="margin-top: 15px; color: rgb(63 61 61); font-size: 14px">Access to customer details is currently disabled by your admin.
          This is not an error. Please contact your admin if you need access.</p>
      </div>

  </div>
</template>

<script>
import CustomerDetailsModal from "@/modules/Customer/components/CustomerDetailsModal.vue";
import {
  changeBookingLocationApi,
  initalizeCustomerInfoComponent,
} from "@/modules/Customer/api";
import moment from "moment/moment";
import { EventBus } from "@/events/event-bus";
import CustomerContact from "./CustomerContact.vue";
import ConfirmationPopup from "../../common/components/ConfirmationPopup.vue";
import ChangeCustomerPopup from "../../Booking/components/ChangeCustomerPopup.vue";
import CustomerInfo from "./CustomerInfo.vue";
import AddCustomersPopup from "./addCustomersPopup.vue";
import SelectCustomers from "../../common/components/SelectCustomers.vue";

export default {
  name: "Customers",
  components: { SelectCustomers, AddCustomersPopup, CustomerInfo },
  props: {
    bookingCustomers: {},
    canSeeCustomer: null,
    loggedUserRole: null,
    itemType: {
      type: String,
      default: "booking",
    },
    customerId: {
      required: true,
    },
    itemId: null,
    allObject: null,
    estimateId: null,
    hasEstimate: 0,
    invoiceId: "",
    fromViewPage: {
      default() {
        return false;
      },
    },
    customerSigned: null,
    customerSignatureId: null,
    showAddress: true,
    signatureLink: "",
    event: null,
    allLabels: null,
    canAddCustomer: null,
    canEditCustomer: null,
    counter: {
      default() {
        return 1;
      },
    },
  },
  data() {
    return {
      bookingCustomersData: this.bookingCustomers,
      key: 0,
    };
  },
  methods: {},
  mounted() {
    EventBus.$on("changeCustomer", (customers) => {
      this.$set(this, "bookingCustomersData", customers);
      this.key++;
    });
  },
};
</script>
<style scoped>
.border-style {
  border-radius: 12px;
}
@media (max-width: 768px) {
  #customer-info-block {
    /*padding: 15px 18px 0px;*/
  }
  .padding-15-18 {
    padding: 15px 18px 0px;
  }
  .no-padding-bottom {
    margin-bottom: 25px;
  }
}
</style>
